<template>
  <v-card>
    <v-card-title v-if="!pdfMode">
      {{ $t('reports.topics.label') }}
    </v-card-title>
    <h2 class="padding-16" v-else>
      {{ $t('reports.topics.label') }}
    </h2>
    <v-card-text>
      <v-data-table
        class="reports-topics-table"
        v-if="topicsArray.length === 1"
        :items="topicsArray[0]"
        :headers="headers"
        dense
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item.label="{ item }">
          {{ $t(`reports.topics.${item.label}`) }}
        </template>
        <template v-slot:item.monthPrice="{ item }">
          <PricesDisplay
            :prices="item.monthPriceCents"
            :contract-currencies="currencies"
            :chosen-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
            :item-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
          />
        </template>
        <template v-slot:item.projectToDatePrice="{ item }">
          <PricesDisplay
            :prices="item.projectToDatePriceCents"
            :contract-currencies="currencies"
            :chosen-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
            :item-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
          />
        </template>
        <template v-slot:item.totalIncReportingMonthPrice="{ item }">
          <PricesDisplay
            :prices="item.totalIncReportingMonthPriceCents"
            :contract-currencies="currencies"
            :chosen-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
            :item-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
          />
        </template>
      </v-data-table>
      <section class="pdf-item" v-else-if="pdfMode && showParts">
        <div v-for="(topics, index) in topicsArray" :key="index" class="padding-16">
          <h1 v-if="topics[0].partId">{{ partsById[topics[0].partId].name }}</h1>
          <v-data-table
              :items="topics"
              :headers="headers"
              dense
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item.label="{ item }">
                {{ $t(`reports.topics.${item.label}`) }}
              </template>
              <template v-slot:item.monthPrice="{ item }">
                <PricesDisplay
                  :prices="item.monthPriceCents"
                  :contract-currencies="currencies"
                  :chosen-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
                  :item-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
                />
              </template>
              <template v-slot:item.projectToDatePrice="{ item }">
                <PricesDisplay
                  :prices="item.projectToDatePriceCents"
                  :contract-currencies="currencies"
                  :chosen-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
                  :item-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
                />
              </template>
              <template v-slot:item.totalIncReportingMonthPrice="{ item }">
                <PricesDisplay
                  :prices="item.totalIncReportingMonthPriceCents"
                  :contract-currencies="currencies"
                  :chosen-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
                  :item-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
                />
              </template>
            </v-data-table>
            <div class="html2pdf__page-break" v-if="index < topicsArray.length - 1"/>
          </div>
      </section>
      <v-expansion-panels
        v-else
        flat
        multiple
        v-model="expandedTopics"
      >
        <v-expansion-panel
          v-for="(topics, index) in topicsArray"
          :key="index"
        >
          <v-expansion-panel-header>
            <div v-if="topics[0].partId">{{ partsById[topics[0].partId].name }}</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-data-table
              :items="topics"
              :headers="headers"
              dense
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item.label="{ item }">
                {{ $t(`reports.topics.${item.label}`) }}
              </template>
              <template v-slot:item.monthPrice="{ item }">
                <PricesDisplay
                  :prices="item.monthPriceCents"
                  :contract-currencies="currencies"
                  :chosen-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
                  :item-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
                />
              </template>
              <template v-slot:item.projectToDatePrice="{ item }">
                <PricesDisplay
                  :prices="item.projectToDatePriceCents"
                  :contract-currencies="currencies"
                  :chosen-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
                  :item-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
                />
              </template>
              <template v-slot:item.totalIncReportingMonthPrice="{ item }">
                <PricesDisplay
                  :prices="item.totalIncReportingMonthPriceCents"
                  :contract-currencies="currencies"
                  :chosen-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
                  :item-currency="item.partId ? { key: partsById[item.partId].currency, value: 1 } : chosenCurrency"
                />
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import { DEFAULT_REPORT } from '@/helpers'

export default {
  name: 'ReportTopics',
  props: {
    report: {
      type: Object,
      default: () => ({ ...DEFAULT_REPORT })
    },
    chosenCurrency: {
      type: Object,
      default: () => ({ })
    },
    currencies: Array,
    showParts: Boolean,
    parts: Array,
    pdfMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      colors: ['blue', 'orange', 'green', 'purple'],
      headers: [
        { text: '', value: 'label' },
        { text: this.$t('reports.topics.monthPrice'), value: 'monthPrice', sortable: false },
        { text: this.$t('reports.topics.monthQuantity'), value: 'monthQuantity', sortable: false },
        { text: this.$t('reports.topics.projectToDatePrice'), value: 'projectToDatePrice', sortable: false },
        { text: this.$t('reports.topics.projectToDateQuantity'), value: 'projectToDateQuantity', sortable: false },
        { text: this.$t('reports.topics.totalIncReportingMonthPrice'), value: 'totalIncReportingMonthPrice', sortable: false },
        { text: this.$t('reports.topics.totalIncReportingMonthQuantity'), value: 'totalIncReportingMonthQuantity', sortable: false }
      ],
      expandedTopics: []
    }
  },
  computed: {
    partsById () {
      return this.parts.reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {})
    },
    topicsArray () {
      return this.showParts ? this.report.topicsByPart : [this.report.topics]
    }
  },
  watch: {
    showParts (v) {
      this.expandedTopics = v ? this.topicsArray.map((i, index) => index) : []
    }
  }
}
</script>

<style lang="scss">
$border-color: rgba(0, 0, 0, 0.12);
$text-color: rgb(0, 0, 0);

.reports-topics-table {
  th:nth-child(2n+4),
  td:nth-child(2n+4) {
    border-left: thin solid $border-color;
  }
}

.padding-16 {
  padding: 16px;
}

.v-data-table {
  th {
    color: $text-color !important;
  }

  p.nowrap.text--secondary {
    color: $text-color !important;
  }

  color: $text-color !important;
}
</style>
